import React from 'react';

import { emotics } from './emotic.module.scss';

const Emotic = ({ emotic: Component, className = '' }) => (
    <Component className={`${emotics} ${className}`} />
);

export default Emotic;
